module.exports = "<div id=\"closed-walkthrough-container\">\n\t<div class=\"hp-inner-center project-paid-walkthrough\">\n\t\t<span class=\"icon icon-thumbs-up\"></span>\n\t    <h1>{{appDetail.paymentInstructions.TotalApproved | currency}} was paid on {{appDetail.fundingRequest.FundingRequestDetail.DisbursementDate | date: 'EEEE, MMMM d'}}. <br/> You can expect to receive the funds within 1-2 business days</h1>\n\t</div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/appDetail/walkthrough/closed/heroFundedTemplate.html
// module id = 645
// module chunks = 1